// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"aJ-z","carouselContainer":"bJ-z"};